import mainViewMixin from '../mainViewMixin';
import { mapState } from 'vuex';
import NiotaClassicApiService from '@/services/niotaClassicApiService';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'ViewNiotaClassicDevicesDevicesList',
  mixins: [mainViewMixin],
  data: function () {
    return {
      isLoadingAccounts: true,
      selectedAccounts: [],
      deviceTypes: [],
      applications: [],
      selectedRows: [],
      editAllFormDialog: false,
      limit: 1000,
      originator: null,
      firstStep: false,
      secondStep: false,
      thirdStep: false,
      addNew: false,
      datasourceType: null,
      qrScanner: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    headerBG() {
      return './img/consumer.png';
    }
  },
  mounted() {
    this.deviceTypeFetchPlain();
    this.applicationsFetchPlain();
    this.originatorFetchPlain();
  },
  methods: {
    getAccountsIdsFromQueryParams() {
      return (this.$route.query.accounts || '').split(',').map(i => parseInt(i, 10));
    },
    deviceTypeFetchPlain() {
      NiotaClassicApiService.deviceTypeFetchPlain().then(res => {
        this.deviceTypes = res.data.devicetypes;
      }).catch(() => {
        this.deviceTypes = [];
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingDeviceTypes'), 'error');
      });
    },
    applicationsFetchPlain() {
      NiotaClassicApiService.applicationsFetchPlain().then(res => {
        this.applications = res.data.applications;
      }).catch(() => {
        this.applications = [];
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingApplications'), 'error');
      });
    },
    originatorFetchPlain() {
      NiotaClassicApiService.originatorsFetchPlain(this.limit).then(res => {
        this.originators = res.data.originators;
      }).catch(() => {
        this.originators = [];
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingOriginators'), 'error');
      });
    },
    getSelectedRows(rows) {
      this.selectedRows = rows;
    },
    editAll() {
      this.editAllFormDialog = true;
    },
    closeEditAllForm() {
      this.editAllFormDialog = false;
    },
    refreshList() {
      this.selectedRows = [];
      setTimeout(() => {
        this.$refs.list.fetchList();
      }, 500);
    },
    selectedApplication(application) {
      this.editedItem.applicationId = application.id;
      this.editedItem = cloneDeep(this.editedItem);
      this.firstStep = false;
      this.secondStep = true;
      this.thirdStep = false;
    },
    selectedOriginator(originator) {
      this.editedItem.originatorId = originator.id;
      this.originator = originator;
      this.getDatasourceType();
      this.editedItem = cloneDeep(this.editedItem);
      this.firstStep = false;
      this.secondStep = false;
      this.thirdStep = true;
    },
    editDevice(item) {
      let originator = this.originators.filter(originator => originator.id === item.originatorId);
      if (originator && originator.length) {
        if (originator[0].datasource) {
          this.datasourceType = originator[0].datasource.type;
        }
      }
      this.editedItem = item;
      this.formDialog = true;
    },
    addDevice() {
      this.editedItem = {};
      this.firstStep = true;
      this.secondStep = false;
      this.thirdStep = false;
    },
    getDatasourceType() {
      this.datasourceType = this.originator.datasource.type;
    },
    resetApplication() {
      delete this.editedItem.originatorId;
      delete this.editedItem.applicationId;
      this.originator = {};
      this.datasourceType = null;
      this.editedItem = cloneDeep(this.editedItem);
      this.firstStep = true;
      this.secondStep = false;
      this.thirdStep = false;
    },
    resetOriginator() {
      delete this.editedItem.originatorId;
      this.originator = {};
      this.datasourceType = null;
      this.editedItem = cloneDeep(this.editedItem);
      this.firstStep = false;
      this.secondStep = true;
      this.thirdStep = false;
      this.addNew = false;
    },
    csvUpload() {
      this.$router.push('/niota-classic/devices/csv/upload');
    },
    resetFilter() {
      this.selectedAccounts = [];
    }
  }
};